import { render } from "./1.LegalTop.vue?vue&type=template&id=4a0e6e00&scoped=true"
import script from "./1.LegalTop.vue?vue&type=script&lang=js"
export * from "./1.LegalTop.vue?vue&type=script&lang=js"

import "./1.LegalTop.vue?vue&type=style&index=0&id=4a0e6e00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0e6e00"]])

export default __exports__